import type { PostContent } from '../api/createPost'
import { LINKEDIN_RESTRICTIONS } from './restrictions'

export const postContent = (
  uploadUrls: { url: string; file: { type: string } }[],
  caption: string,
  title: string,
): PostContent | { type: 'invalid'; reason: string } => {
  // Validate caption length
  if (caption && caption.length > LINKEDIN_RESTRICTIONS.caption.maxLength) {
    return {
      type: 'invalid',
      reason: `Caption too long (${caption.length}/${LINKEDIN_RESTRICTIONS.caption.maxLength} characters)`,
    }
  }

  if (uploadUrls.length === 0) {
    return { type: 'text', caption }
  }

  if (uploadUrls.length === 1) {
    if (uploadUrls[0]!.file.type.startsWith('image/')) {
      return {
        type: 'image',
        url: uploadUrls[0]!.url,
        caption,
      }
    }

    if (uploadUrls[0]!.file.type.startsWith('video/')) {
      return {
        type: 'video',
        url: uploadUrls[0]!.url,
        caption,
      }
    }

    return {
      type: 'document',
      url: uploadUrls[0]!.url,
      caption,
      title: title,
    }
  }

  if (!uploadUrls.every(({ file }) => file.type.startsWith('image/'))) {
    return { type: 'invalid', reason: 'LinkedIn multi-image posts can only contain images' }
  }

  // Validate multi-image count
  if (uploadUrls.length > LINKEDIN_RESTRICTIONS.multiImage.maxItems) {
    return {
      type: 'invalid',
      reason: `Too many images (${uploadUrls.length}/${LINKEDIN_RESTRICTIONS.multiImage.maxItems} max)`,
    }
  }

  return {
    type: 'multiImage',
    urls: uploadUrls.map(({ url }) => url),
    caption,
  }
}
